import styled from 'styled-components';

import { Z_INDEX } from '@/constants';

export const InfoOverLay = () => {
  return <InfoOverLayDiv />;
};

const InfoOverLayDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 1.5rem;
  z-index: ${Z_INDEX.overlay.panel}; // Ensure it appears above the card
  cursor: default;
  pointer-events: none; /* Let events pass through to elements behind; card uses pointer-events: none when disabled */
`;
